module.exports = __webpack_public_path__ + "img/scope-trovo.50e2dd00.png";